import React, {useEffect, useRef} from 'react';
import  {MapContainer, TileLayer, Marker,Popup, Polyline, useMap} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L, { latLngBounds } from 'leaflet';
import DateUtils from '../utils/DateUtils';
import markerIconPng from '../assets/marker-icon-maps.svg'
import markerShadowPng from '../assets/marker-shadow.png'
import markerIconPngActive from '../assets/marker-icon-maps-active.svg'

function ChangeView({ markers }) {
    const map = useMap();
    
    let markerBounds = latLngBounds([]);
    markers.forEach(marker => {
        markerBounds.extend([marker.latitude, marker.longitude])
    })
    map.fitBounds(markerBounds)   // <===== Error: Bounds are not valid.
    return null;
}


const MapComponent = (props) => {
    let position = props.data && props.data.positions && props.data.positions.length > 0 ? [props.data.positions[props.data.positions.length-1].latitude, props.data.positions[props.data.positions.length-1].longitude] : [47.410897, 12.947836];

    const markerIcon = L.icon({
      iconSize: [36, 51],
      iconAnchor: [16, 43],
      popupAnchor: [2, -40],
      iconUrl: markerIconPng,
      shadowUrl: markerShadowPng
    });

    const markerIconActive = L.icon({
      iconSize: [36, 51],
      iconAnchor: [16, 43],
      popupAnchor: [2, -40],
      iconUrl: markerIconPngActive,
      shadowUrl: markerShadowPng,
    });

    const connectWaypoints = (data) => {
      let c = [];
      for(let i in data) {
          let x = data[i].latitude;
          let y = data[i].longitude;
          c.push([x, y]);
      }
      return c;
    }
     
    const markers = props.data.positions;
    
   return (
        
          <MapContainer
            className='mapContainer'
            center={position}
            zoom={10}
            scrollWheelZoom={true} 
          >
            <ChangeView markers={markers} />
            <TileLayer
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
         {props.data.positions.map((elem, i) => {
            return (
              <Marker 
                key={i} 
                zIndexOffset={props.data.positions.length === (i+1) ? 1000 : i}
                position={{lat:elem.latitude, lng: elem.longitude}}
                icon = {props.data.positions.length === (i+1) ? markerIconActive : markerIcon}>
                <Popup>
                  <b>{props.data.positions.length === (i+1) ? "Letzte " : ""} {"Position Nr. "+(i+1)} </b><br/><br/>
                  <span>
                    Koordinaten<br/>
                    {elem.latitude + " " + elem.longitude}
                  </span><br/>
                  <span>
                    Datum<br />
                    <DateUtils timestamp={elem.timestamp}/><br />
                  </span>
                </Popup>
                <Polyline color="black" positions={connectWaypoints(props.data.positions)} />
              </Marker>
            )
          })};
          </MapContainer>
      );
  }
  
  export default MapComponent



